// Kyvexus — un solo archivo JS para todo el diseño propio, cargado con defer.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initContadores();
  initMarquesina();
});

function initReveal() {
  var els = document.querySelectorAll('.kv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('kv-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('kv-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-kv-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-kv-imagen-principal]');
  var minis = galeria.querySelectorAll('[data-kv-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full) return;
      principal.src = full;
      minis.forEach(function (m) { m.classList.remove('kv-mini-activa'); });
      mini.classList.add('kv-mini-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-kv-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-kv-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-kv-opcion]');
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-kv-precio]');
  var precioCompareEl = document.querySelector('[data-kv-precio-compare]');
  var botonComprar = form.querySelector('[data-kv-boton-comprar]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    if (!selects.length) return;
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
    if (!variante) return;
    inputId.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneda(variante.compare_at_price);
        precioCompareEl.hidden = false;
      } else {
        precioCompareEl.hidden = true;
      }
    }
    if (botonComprar) {
      var span = botonComprar.querySelector('span');
      if (variante.available) {
        botonComprar.disabled = false;
        botonComprar.removeAttribute('aria-disabled');
        if (span) span.textContent = botonComprar.getAttribute('data-texto-disponible') || span.textContent;
      } else {
        botonComprar.disabled = true;
        if (span) span.textContent = botonComprar.getAttribute('data-texto-agotado') || 'Sold out';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initContadores() {
  var els = document.querySelectorAll('[data-kv-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-kv-contador')) || 0;
      var dur = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)) + (el.getAttribute('data-kv-sufijo') || '');
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('[data-kv-marquesina]').forEach(function (track) {
    if (track.dataset.kvDuplicado) return;
    track.innerHTML += track.innerHTML;
    track.dataset.kvDuplicado = 'true';
  });
}
